import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from 'react-icons/fa';
import InternalHeader from '../InternalHeader';
import Sidebar from '../Sidebar';
import '../Patients/CreatePatient.css'; // Assuming you're using the same CSS
import AccessControl from '../AccessControl';
import LinkMap from '../LinkMap/LinkMap';

const CreateCategory = () => {
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [newItem, setNewItem] = useState({
        Name: ""
    });
    const [existingCategories, setExistingCategories] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const linkData = [
        { label: 'Inventory', path: '/inventory' },
        { label: 'Create Category', path: '/create-category' },
    ];

    useEffect(() => {
        // Fetch existing categories when component mounts
        const fetchCategories = async () => {
            try {
                const response = await fetch('https://api.hgcdental.clinic/api/category');
                const data = await response.json();
                setExistingCategories(data);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, []);

    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewItem({
            ...newItem,
            [name]: value,
        });
        // Clear errors when user types
        if (error) setError(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if name is empty
        if (!newItem.Name.trim()) {
            setError("Category name cannot be empty");
            return;
        }

        // Check if category already exists (case insensitive)
        const categoryExists = existingCategories.some(
            category => category.Name.toLowerCase() === newItem.Name.toLowerCase() && !category.isArchived
        );

        if (categoryExists) {
            setError(`A category with the name "${newItem.Name}" already exists`);
            return;
        }

        try {
            const response = await fetch('https://api.hgcdental.clinic/api/category', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newItem),
            });

            if (!response.ok) {
                throw new Error('Failed to create category');
            }

            const data = await response.json();
            setSuccess(`Category "${newItem.Name}" created successfully!`);
            setError(null);
            // Reset form
            setNewItem({ Name: "" });

            // Refresh the categories list
            const refreshResponse = await fetch('https://api.hgcdental.clinic/api/category');
            const refreshData = await refreshResponse.json();
            setExistingCategories(refreshData);

        } catch (error) {
            console.error('Error adding item:', error);
            setError(error.message);
        }
    };

    return (
        <AccessControl>
            <div className={`create-patient-container ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <InternalHeader moduleName="Create Category" toggleSidebar={toggleSidebar} />
                <div className="create-patient-content">
                    <Sidebar isSidebarVisible={isSidebarVisible} />
                    <div className="create-patient">
                        <LinkMap
                            links={linkData}
                            moduleName="Category"
                            moduleIcon="inventory"
                        />
                        <div>
                            <button className="create-patient-button" onClick={handleSubmit}>
                                <FaSave /> Save
                            </button>
                        </div>
                        <div className="create-patient-form">
                            <h2>Create New Category</h2>

                            {/* Display success message */}
                            {success && (
                                <div className="alert alert-success">
                                    {success}
                                </div>
                            )}

                            {/* Display error message */}
                            {error && (
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            )}

                            {/* Name Field */}
                            <div className="input-group">
                                <label className="label">Name</label>
                                <input
                                    type="text"
                                    name="Name"
                                    value={newItem.Name}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccessControl>
    );
};

export default CreateCategory;